import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import { huddleScheduleAdjustmentsHasData } from '@utils/dashboardHuddle.util'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import { HuddleMetricGrid } from '../HuddleMetricGrid.component'
import type { HuddleDashboard } from '../useHuddleDashboard'

type ScheduleAdjustmentsCardProps = {
  titleHref: string
  scheduleAdjustments: HuddleDashboard['scheduleAdjustmentsApi']
  className?: string
}

export function ScheduleAdjustmentsCard({
  titleHref,
  scheduleAdjustments,
  className = 'dashboard-huddle-patients-card dashboard-huddle-full-row dashboard-huddle-yesterday-schedule-row',
}: ScheduleAdjustmentsCardProps): React.ReactElement {
  const { summaryMetrics, loading, data } = scheduleAdjustments
  const isEmpty = shouldShowDashboardSectionEmpty(
    loading,
    huddleScheduleAdjustmentsHasData(data),
  )
  const pending = isDashboardSectionPending(loading, data != null)

  return (
    <DashboardSectionCard
      title="Schedule & adjustments"
      titleHref={titleHref}
      className={className}
      loading={pending}
      skeleton={{ metrics: 4 }}
      isEmpty={isEmpty}
    >
      <HuddleMetricGrid metrics={summaryMetrics} />
    </DashboardSectionCard>
  )
}
